import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './main.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CallOfferClientComponent } from './call-offer-client/call-offer-client.component';
import { CallOfferNonAbonneComponent } from './call-offer-non-abonne/call-offer-non-abonne.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { EmployeeComponent } from './employee/employee.component';
import { ExternalConsultantComponent } from './external-consultant/external-consultant.component';
import { ListAbonnementsComponent } from './list-abonnements/list-abonnements.component';
import { ListUsersComponent } from './list-users/list-users.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { SupplierComponent } from './supplier/supplier.component';
import { UserNonAbonneComponent } from './user-non-abonne/user-non-abonne.component';
import { CandidatNonAbonneComponent } from './candidat-non-abonne/candidat-non-abonne.component';
import { RateWegestuComponent } from './rate-wegestu/rate-wegestu.component';
import { MessageEsnComponent } from './message-esn/message-esn.component';
import { TutoEsnComponent } from './tuto-esn/tuto-esn.component';
import { FaqEsnComponent } from './faq-esn/faq-esn.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { ContactComponent } from './contact/contact.component';
import { RateEsnComponent } from './rate-esn/rate-esn.component';
import { DossierComponent } from './dossier/dossier.component';
import { ProfilCandidatComponent } from './profil-candidat/profil-candidat.component';
import { DetailcompanyComponent } from './detailcompany/detailcompany.component';
import { DetailsOfferComponent } from './details-offer/details-offer.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { TutoclientComponent } from './tuto-client/tutoclient.component';
import { CandidaturecallofferComponent } from './candidaturecalloffer/candidaturecalloffer/candidaturecalloffer.component';
import { CandidatclientfinalComponent } from './candidat-client-final/candidatclientfinal/candidatclientfinal.component';
import { OfferDetailsComponent } from './list-abonnements/components/offer-details/offer-details.component';
import { ChangeOfferComponent } from './list-abonnements/components/change-offer/change-offer.component';
import { CallOffreBaremeComponent } from './call-offre-bareme/call-offre-bareme.component';
import { ListReviewsComponent } from './settings/components/list-reviews/list-reviews/list-reviews.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { DetailCraComponent } from './cra-abonne/components/detail-cra/detail-cra/detail-cra.component';
import { NotificationComponent } from './notification/notification/notification.component';
import { ListesncallofferComponent } from './list-esn-calloffer/listesncalloffer.component';
import { SuggestioncallofferclientfinalComponent } from './suggestion-calloffer-clientfinal/suggestioncallofferclientfinal.component';
import { ProfilcandidatanonymeComponent } from './profil-candidat-anonyme/profilcandidatanonyme.component';
import { PaymentDetailsComponent } from './list-abonnements/components/payment-details/payment-details.component';
import { AddappeloffreComponent } from './add-call-offre/addappeloffre/addappeloffre.component';
import { DetailcallofferclientfinalComponent } from './detail-calloffer-clientfinal/detailcallofferclientfinal/detailcallofferclientfinal.component';
import { DetailEmployeeComponent } from './detail-employee/detail-employee.component';
import { CvCandidatAnonymeComponent } from './cv-candidat_anonyme/cv-candidat-anonyme/cv-candidat-anonyme.component';
import { ContactEsnComponent } from './contact-esn/contact-esn.component';
import { ChangeEmailComponent } from './change-email/change-email.component';
import { ConsultantEnattenteComponent } from './consultant-enattente/consultant-enattente.component';
import { clientFinalGuard } from '@core/guards/client-final.guard';
import { esnAbonneeGuard } from '@core/guards/esn-abonnee.guard';
import { DossierCandidatureComponent } from './call-offer-abonnee/components/dossier-candidature/dossier-candidature.component';
import { DashboardclientComponent } from './dashboard-client/dachbordclient/dashboardclient.component';
import { SubscriptionHasFeatureGuard } from 'app/guards/subscription-has-feature.guard';
import { SubscribedEsnGuard } from '@core/guards/subscribed.guard';
import { TemporaryCloseGuard } from '@core/guards/temporary-close.guard';
import { IntervenerRoleGuard } from '@core/guards/intervener-role.guard';
import { EvaluationPvComponent } from './evaluation-pv/evaluation-pv.component';
import { AddIntervenantComponent } from './list-users/add-intervenant/add-intervenant.component';
import { UpdateIntervenantComponentNew} from './list-users/update-intervenant/update-intervenant.component';
import { UpdateIntervenantComponent } from './update-intervenant/update-intervenant/update-intervenant.component';


const routees: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: 'accueil',
        component: DashboardComponent,
        canActivate: [SubscribedEsnGuard], 
      },
      {
        path: 'evaluation-pv',
        component: EvaluationPvComponent,
      },
      {
        path: 'dashbord',
        component: DashboardclientComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'alerts',
        loadChildren: () =>
          import('./alert-client/alert-client.module').then(
            (m) => m.AlertClientModule
          ),
        canActivate: [TemporaryCloseGuard.canActivate]

      },
      {
        path: 'alert',
        loadChildren: () =>
          import('./alerts-abonnee/alerts.module').then((m) => m.AlertsModule),
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'appels-offres',
        loadChildren: () =>
          import('./call-offer-abonnee/call-offer.module').then(
            (m) => m.CallOfferModule
          ),
        canActivate: [esnAbonneeGuard.canActivate]
      },
      {
        path: 'liste-appels-offres',
        component: CallOfferClientComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      { 
        path: 'appel-offre-non-abonnee',
        component: CallOfferNonAbonneComponent,

      },
      {
        path: 'offres-appel',
        loadChildren: () =>
          import('./call-offer-abonnee/call-offer.module').then(
            (m) => m.CallOfferModule
          ),
          canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'detail-offre/:id',
        component: DetailsOfferComponent,
        canActivate: [clientFinalGuard.canActivate]
      },
      {
        path: 'detail-offre-clientfinal/:id',
        component: DetailcallofferclientfinalComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'ajout-appel',
        component: AddappeloffreComponent,
        canActivate: [TemporaryCloseGuard.canActivate]        
      },
      {
        path: 'abonnement-detail',
        component: OfferDetailsComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'changer-offre',
        component: ChangeOfferComponent,
      },
      {
        path: 'liste-candidats',
        component: CandidatNonAbonneComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'candidatsclientfinal',
        component: CandidatclientfinalComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },

      {
        path: 'candidature-appel-offre/:id',
        component: CandidaturecallofferComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'list-esn-call-offer/:id',
        component: ListesncallofferComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'contacterEntreprise',
        component: ContactEsnComponent,
        canActivate: [SubscribedEsnGuard], 
      },
      {
        path: 'suggestion-call-offer/:id',
        component: SuggestioncallofferclientfinalComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'profil-candidats',
        component: ProfilCandidatComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'profil-candidats-anonyme/:id',
        component: ProfilcandidatanonymeComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'cvcandidatanonyme',
        component: CvCandidatAnonymeComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path:'dossier-candidature/:id/:user_id/:type/:applyid',
        component:DossierCandidatureComponent

      },
      {
        path: 'candidats',
        loadChildren: () =>
          import('./candidats-abonnee/candidats.module').then(
            (m) => m.CandidatsModule
          ),

      },
      {
        path: 'chat',
        loadChildren: () =>
          import('./chat/chat.module').then((m) => m.ChatModule),
        canActivate: [SubscribedEsnGuard],
      },
      {
        path: 'nos-clients',
        loadChildren: () =>
          import('./clients/clients.module').then((m) => m.ClientsModule),
        canActivate: [SubscribedEsnGuard],
      },
      {
        path: 'consultants',
        loadChildren: () =>
          import('./consultant/consultant.module').then(
            (m) => m.ConsultantModule
          ),
          canActivate: [SubscribedEsnGuard],
      },
      {
        path: 'contacter-nous',
        component: ContactUsComponent,
      },
      {
        path: 'detail-cra',
        component: DetailCraComponent,
        canActivate: [SubscriptionHasFeatureGuard],
        data: { featureName: 'CRA' },
      },
      {
        path: 'cra',
        canActivate: [SubscriptionHasFeatureGuard],
        data: { featureName: 'CRA' },
        loadChildren: () =>
          import('./cra-abonne/cra.module').then((m) => m.CraModule),
      },
      {
        path: 'cra',
        loadChildren: () =>
          import('./cra-client-final/cra-client-final.module').then(
            (m) => m.CraClientFinalModule
          ),
          canActivate: [TemporaryCloseGuard.canActivate]

      },
      {
        path: 'entreprises',
        loadChildren: () =>
          import('./entreprises/entreprises.module').then(
            (m) => m.EntreprisesModule
          ),
        // canActivate: [esnAbonneeGuard.canActivate]
      },
      {
        path: 'employee',
        component: EmployeeComponent,
        canActivate: [TemporaryCloseGuard.canActivate]

      },
      {
        path: 'detailemployee',
        component: DetailEmployeeComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'notifications',
        component: NotificationComponent,
      },
      {
        path: 'detailcompany/:id/:type',
        component: DetailcompanyComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'updateintervenant',
        component:UpdateIntervenantComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'esn-offres-emploi',
        loadChildren: () =>
          import('./esn-job-offer/esn-job-offer.module').then(
            (m) => m.EsnJobOfferModule
          ),
      },
      {
        path: 'evaluation',
        loadChildren: () =>
          import('./evaluation-abonnee/evaluation.module').then(
            (m) => m.EvaluationModule
          ),
          canActivate: [SubscriptionHasFeatureGuard],
          data: { featureName: 'Créer évaluations consultants' },
      },
      {
        path: 'evaluations',
        loadChildren: () =>
          import('./evaluation-client/evaluation-client.module').then(
            (m) => m.EvaluationClientModule
          ),
          canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'profil-entreprise',
        loadChildren: () =>
          import('./details-profil/details-profil.module').then(
            (m) => m.DetailsProfilModule
          ),
      },
      {
        path: 'consultant-externe',
        component: ExternalConsultantComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'consultant-attente',
        component: ConsultantEnattenteComponent,
        canActivate: [TemporaryCloseGuard.canActivate]

      },
      {
        path: 'change-mot-de-passe',
        component: ChangePasswordComponent,
      },
      {
        path: 'change-email',
        component: ChangeEmailComponent,
      },
      {
        path: 'faq',
        loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
      },
      {
        path: 'offres-emploi',
        loadChildren: () =>
        import('./job-offer/job-offer.module').then((m) => m.JobOfferModule),
        canActivate: [SubscribedEsnGuard], 
      },
      {
        path: 'notre-compte',
        component: ListAbonnementsComponent,
        canActivate: [IntervenerRoleGuard]
      },
      {
        path: 'intervenants',
        component: ListUsersComponent,
        canActivate: [SubscribedEsnGuard, IntervenerRoleGuard], 
      },
      {
        path: 'intervenants/ajout-intervenant',
        component: AddIntervenantComponent,
        canActivate: [SubscribedEsnGuard, IntervenerRoleGuard], 
      },
      {
        path: 'intervenants/modification-intervenant',
        component: UpdateIntervenantComponentNew,
        canActivate: [SubscribedEsnGuard, IntervenerRoleGuard], 
      },

      {
        path: 'projets',
        loadChildren: () =>
          import('./projects/project.module').then((m) => m.ProjectModule),
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'paramètres',
        loadChildren: () =>
          import('./settings/settings.module').then((m) => m.SettingsModule),
        canActivate: [SubscribedEsnGuard],
      },
      {
        path: 'abonner',
        component: SubscribeComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'contact',
        component: ContactComponent,
      },
      {
        path: 'dossier-competence',
        component: DossierComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'fournisseurs',
        component: SupplierComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'utilisateurs',
        loadChildren: () =>
          import('./user-client/user-client.module').then(
            (m) => m.UserClientModule
          ),
          canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'user-non-abonnee',
        component: UserNonAbonneComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'evaluer-wegestu',
        component: RateWegestuComponent,
      },

      {
        path: 'list-reviews',
        component: ListReviewsComponent,
      },
      {
        path: 'evaluer-esn',
        component: RateEsnComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'messages',
        component: MessageEsnComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'tuto',
        component: TutoEsnComponent,
      },
      {
        path: 'tutoclient',
        component: TutoclientComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'faq-esn',
        component: FaqEsnComponent,
      },

      {
        path: 'invoices',
        component: InvoicesComponent,
        //canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'payement-details',
        component: PaymentDetailsComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },

      {
        path: 'call-offer-bareme',
        component: CallOffreBaremeComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },
      {
        path: 'offer-details',
        component: OfferDetailsComponent,
      },

      {
        path: 'not-found',
        component: NotFoundComponent,
      },
      {
        path: 'profil-intervenant',
        component: UpdateIntervenantComponent,
        canActivate: [TemporaryCloseGuard.canActivate]
      },

    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routees)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
